module.exports = __webpack_public_path__ + "img/icon_telephone.18f06a72.svg";